import { Controller } from "@hotwired/stimulus"

// Bandeau « Pour votre établissement » : les onglets (Jusqu'à 10 / 11 à 25 /
// 26 et plus) basculent le prix, l'accroche et le bouton d'action du même
// bandeau, sans recharger la page.
export default class extends Controller {
  static targets = ["tab", "head", "cta"]
  static values = { tier: String }

  select(event) {
    this.tierValue = event.params.tier
  }

  tierValueChanged() {
    this.tabTargets.forEach((el) => el.classList.toggle("is-active", el.dataset.tier === this.tierValue))
    this.headTargets.forEach((el) => (el.hidden = el.dataset.tier !== this.tierValue))
    this.ctaTargets.forEach((el) => (el.hidden = el.dataset.tier !== this.tierValue))
  }
}
